var map = {
	"./": 316,
	"./Content": 1142,
	"./Content.dictionary": 1144,
	"./Content.dictionary.json": 1144,
	"./Content.jsx": 1142,
	"./ContentDeferred": 366,
	"./ContentDeferred.jsx": 366,
	"./InterestingMatches": 1024,
	"./InterestingMatches/": 1024,
	"./InterestingMatches/InterestingMatches.dictionary": 1040,
	"./InterestingMatches/InterestingMatches.dictionary.json": 1040,
	"./InterestingMatches/InterestingMatches.module.scss": 842,
	"./InterestingMatches/actions": 97,
	"./InterestingMatches/actions.ts": 97,
	"./InterestingMatches/components/Contetnt": 931,
	"./InterestingMatches/components/Contetnt/": 931,
	"./InterestingMatches/components/Contetnt/Content.dictionary": 976,
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": 976,
	"./InterestingMatches/components/Contetnt/Content.module.scss": 1039,
	"./InterestingMatches/components/Contetnt/index": 931,
	"./InterestingMatches/components/Contetnt/index.tsx": 931,
	"./InterestingMatches/components/Match": 848,
	"./InterestingMatches/components/Match/": 848,
	"./InterestingMatches/components/Match/Match.dictionary": 854,
	"./InterestingMatches/components/Match/Match.dictionary.json": 854,
	"./InterestingMatches/components/Match/index": 848,
	"./InterestingMatches/components/Match/index.tsx": 848,
	"./InterestingMatches/components/Sport": 975,
	"./InterestingMatches/components/Sport.tsx": 975,
	"./InterestingMatches/components/Stage": 880,
	"./InterestingMatches/components/Stage.tsx": 880,
	"./InterestingMatches/components/Tournament": 898,
	"./InterestingMatches/components/Tournament.jsx": 898,
	"./InterestingMatches/components/Union": 932,
	"./InterestingMatches/components/Union.jsx": 932,
	"./InterestingMatches/constants": 933,
	"./InterestingMatches/constants.ts": 933,
	"./InterestingMatches/index": 1024,
	"./InterestingMatches/index.jsx": 1024,
	"./InterestingMatches/reducer": 295,
	"./InterestingMatches/reducer/": 295,
	"./InterestingMatches/reducer/entities": 351,
	"./InterestingMatches/reducer/entities.js": 351,
	"./InterestingMatches/reducer/grid": 352,
	"./InterestingMatches/reducer/grid.js": 352,
	"./InterestingMatches/reducer/index": 295,
	"./InterestingMatches/reducer/index.js": 295,
	"./InterestingMatches/selectors": 834,
	"./InterestingMatches/selectors/": 834,
	"./InterestingMatches/selectors/entities": 275,
	"./InterestingMatches/selectors/entities.ts": 275,
	"./InterestingMatches/selectors/grid": 853,
	"./InterestingMatches/selectors/grid.ts": 853,
	"./InterestingMatches/selectors/index": 834,
	"./InterestingMatches/selectors/index.ts": 834,
	"./LandingPage.module.scss": 1185,
	"./MatchOfTheDay": 1025,
	"./MatchOfTheDay/": 1025,
	"./MatchOfTheDay/actions": 305,
	"./MatchOfTheDay/actions.ts": 305,
	"./MatchOfTheDay/components/Carousel": 977,
	"./MatchOfTheDay/components/Carousel/": 977,
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": 1143,
	"./MatchOfTheDay/components/Carousel/index": 977,
	"./MatchOfTheDay/components/Carousel/index.tsx": 977,
	"./MatchOfTheDay/components/MainStakes": 934,
	"./MatchOfTheDay/components/MainStakes/": 934,
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": 1041,
	"./MatchOfTheDay/components/MainStakes/index": 934,
	"./MatchOfTheDay/components/MainStakes/index.tsx": 934,
	"./MatchOfTheDay/components/MatchTile": 978,
	"./MatchOfTheDay/components/MatchTile/": 978,
	"./MatchOfTheDay/components/MatchTile/MatchDetails": 1042,
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": 1042,
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": 979,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": 1043,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": 1043,
	"./MatchOfTheDay/components/MatchTile/index": 978,
	"./MatchOfTheDay/components/MatchTile/index.tsx": 978,
	"./MatchOfTheDay/images/background.svg": 1199,
	"./MatchOfTheDay/images/pattern.svg": 1200,
	"./MatchOfTheDay/index": 1025,
	"./MatchOfTheDay/index.tsx": 1025,
	"./MatchOfTheDay/reducer": 353,
	"./MatchOfTheDay/reducer.ts": 353,
	"./MatchOfTheDay/selectors": 891,
	"./MatchOfTheDay/selectors/": 891,
	"./MatchOfTheDay/selectors/entities": 282,
	"./MatchOfTheDay/selectors/entities.ts": 282,
	"./MatchOfTheDay/selectors/grid": 922,
	"./MatchOfTheDay/selectors/grid.ts": 922,
	"./MatchOfTheDay/selectors/index": 891,
	"./MatchOfTheDay/selectors/index.ts": 891,
	"./MatchOfTheDay/utils/get-match-ids-from-banners": 1086,
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": 1086,
	"./MiniBanners": 1026,
	"./MiniBanners/": 1026,
	"./MiniBanners/MiniBanners": 980,
	"./MiniBanners/MiniBanners.module.scss": 1044,
	"./MiniBanners/MiniBanners.tsx": 980,
	"./MiniBanners/components/Content": 899,
	"./MiniBanners/components/Content/": 899,
	"./MiniBanners/components/Content/Content": 881,
	"./MiniBanners/components/Content/Content.module.scss": 935,
	"./MiniBanners/components/Content/Content.tsx": 881,
	"./MiniBanners/components/Content/index": 899,
	"./MiniBanners/components/Content/index.ts": 899,
	"./MiniBanners/index": 1026,
	"./MiniBanners/index.ts": 1026,
	"./images/telegram.svg": 1201,
	"./index": 316,
	"./index.tsx": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1266;
module.exports = webpackContext;